<template>
    <div  >
            <top-navbar></top-navbar>
    
    
            <div  class="mb-5  background_color " >
              <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> Home </router-link><span  class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/msalespeople/index"> Manage Sales Executive </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Create Sales Executive  </h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
                <div style=" padding-bottom: 100px;" class="container-fluid ">
                <div class="card bdr-rad2 mt-1 shadow p-2 ">
                <div class="card-body">


                    <form @submit.prevent="SaveProduct()" >

<div class="row">
 
  
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Sales Person Name</label>
            <input  v-model="alldata.name"  style="font-size: small;" class="form-control bdr-rad" required>
    </div>
  </div>
  <div  class="col-md-3">
    <div class="form-group ">
            <label class="custom-label"  style="font-size: small;">Area </label>
           <input  v-model="alldata.area"  style="font-size: small;" class="form-control bdr-rad" required>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Type </label>
          <v-select label="label"  v-model="alldata.type" :options="types" ></v-select>
    </div>
  </div>

 <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Contact No</label>
            <input  v-model="alldata.contact_no"  style="font-size: small;" class="form-control bdr-rad" >
    </div>
  </div>


</div>















   

    <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="submit" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad"><UpdatePassword></UpdatePassword></button>
    </div>
    </div>
    <br><br>


</form>




                </div>
                </div>
           
            </div>
           
          </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
import UpdatePassword from '@/pages/User/UpdatePassword.vue'
     
    
    
      export default {

        mounted(){
    this.LoadData()
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
             'id':this.$route.query.id,
        total:0,
        selectedOption: null, // Store the selected option
       

        brands:[],
        suppliers:[],
        vehicles:[],
        Locations:[],
        alldata: {
      name: '',
      area: '',
      type: '',
      contact_no: ''
    },
       
      
      types: [
            { label: 'Select Category', value: '' },
            { label: 'Spare Parts', value: '1' },
            { label: 'Batteries', value: '2' },
            { label: 'Vehicles', value: '3' },
            // Add more options as needed
        ],
        productfuel: [
            { label: 'Select Fuel Type', value: '' },
            { label: 'Diesel', value: 'Diesel' },
            { label: 'petrol', value: 'petrol' },
            { label: 'both', value: 'both' },
            // Add more options as needed
        ],
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        	UpdatePassword,
	},

        methods : {


            async LoadData() {
       
      console.log(this.alldata);
   
    console.log("amila");
       try {
         const { data} = await  axios.get('/msalespeople/loadalldata?id='+this.id,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
        if(data.status==200){
            this.alldata = data.alldata;
          
        

        }
          
           
         
       } catch (error) {
         console.log(error.response);
       }
     },
       

     

 

    async SaveProduct() {
       
      console.log(this.alldata);
   
    console.log("amila");
       try {
         const { data} = await  axios.post('/msalespeople/update?id='+this.id,{userid:this.userid,alldata:this.alldata},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
        if(data.status==200){
          this.$router.push('/msalespeople/index');
        }
          
           
         
       } catch (error) {
         console.log(error.response);
       }
     },
       

     

    },
    
    }
    
    </script>

    <style scoped>
.vs__dropdown-toggle {
      border-radius: 10px !important;
    border-top-left-radius: 10px !important;
    border-top-right-radius: 10px !important;
    border-bottom-right-radius: 10px !important;

}

    </style>
    